import React, {useEffect, useState} from 'react'
import i18n from 'i18next'
import PropTypes from 'prop-types'
import AbteilungDialog from '#components/m/Versetzungsplan/AbteilungDialog'
import Button from '#components/a/Button'
import FlyoutAnchor from '#components/m/Flyout/FlyoutAnchor'
import {FlyoutPivot} from '#components/m/Flyout/FlyoutPivot'
import {FlyoutPosition} from '#components/m/Flyout/FlyoutPosition'
import {connect, shallowEqual, useSelector} from 'react-redux'
import {VersetzungsplanHeaderButtons} from '#components/m/Versetzungsplan/VersetzungsplanHeaderButtons'

function AbteilungCreateButton({createDialogOpen, setCreateDialogOpen, versetzungsplaene, azubis, isPrimary}) {
  const [showAbteilungDialog, setShowAbteilungDialog] = useState()

  useEffect(() => {
    if (createDialogOpen === false) {
      closeAbteilungDialog()
    }
  }, [createDialogOpen])

  const closeAbteilungDialog = () => {
    setShowAbteilungDialog(false)
    setCreateDialogOpen(false)
  }

  const abteilungDialogVisibilityChanged = visible => {
    setShowAbteilungDialog(visible)
    setCreateDialogOpen(visible)
  }

  return (
    <FlyoutAnchor
      flyoutPosition={FlyoutPosition.bottom}
      flyoutPivot={FlyoutPivot.end}
      openSync={showAbteilungDialog}
      flyoutVisibilityChanged={abteilungDialogVisibilityChanged}
      flyoutDistance={15}
      flyoutContent={
        <AbteilungDialog closed={closeAbteilungDialog} versetzungsplaene={versetzungsplaene} azubis={azubis} />
      }
      startWidth={320}
      startHeight={470}
      stayOpenOnOutsideClick={true}>
      <Button
        data-testid="create_abteilung"
        id="create_abteilung"
        text={i18n.t('abteilung_erstellen')}
        variant={isPrimary ? 'primary' : 'secondary'}
      />
    </FlyoutAnchor>
  )
}

AbteilungCreateButton.propTypes = {
  azubis: PropTypes.array.isRequired,
  versetzungsplaene: PropTypes.array,
  isPrimary: PropTypes.bool,
  setCreateDialogOpen: PropTypes.func.isRequired,
  createDialogOpen: PropTypes.bool.isRequired,
}

function mapStateToProps(state) {
  return {
    versetzungsplaene: state.versetzungsplan.versetzungsplaene,
  }
}

export default connect(mapStateToProps)(AbteilungCreateButton)
